<script>
    export let size = 24
    export let color = '#C5281C'
    export let style = ''
    export let title = null
    export let rotate = false
</script>

<svg
    xmlns="http://www.w3.org/2000/svg"
    class="ionicon"
    width={`${size}`}
    height={`${size}`}
    {style}
    viewBox="0 0 512 512"
>
    {#if title}
        <title>{title}</title>
    {/if}
    <path
        d="M434.67 285.59v-29.8c0-98.73-80.24-178.79-179.2-178.79a179 179 0 00-140.14 67.36m-38.53 82v29.8C76.8 355 157 435 256 435a180.45 180.45 0 00140-66.92"
        fill="none"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="32"
    ></path>
    <path
        fill="none"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="32"
        d="M32 256l44-44 46 44M480 256l-44 44-46-44"
    ></path>
    {#if rotate} <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="-360 0 0" to="0 0 0" dur="1.5s" additive="sum" repeatCount="indefinite" /> {/if}
</svg>
